// extracted by mini-css-extract-plugin
export default {"app":"sOPun9"};